import React from 'react'
import DfbHeadline from '@dfb/gatsby-dfb-theme/src/components/ui-kit/dfb_headline'
import DfbRte from '@dfb/gatsby-dfb-theme/src/components/ui-kit/dfb_rte'
import Section from '@dfb/gatsby-dfb-theme/src/components/blocks/section'

type FanclubMap = {
  name: string
  city: string
  federal_state: string
}

type FanclubProps = {
  headline: string
  text: string
  fanclub_map_folder: Array<FanclubMap>
}

const MFanclubTable = ({ data }: { data: FanclubProps }) => {
  const { headline, text, fanclub_map_folder } = data

  return (
    <Section baseClass="m-PaginatedTable" data={data} defaultPadding="large">
      <div className="m-PaginatedTable-wrapper">
        <div className="m-PaginatedTable-container">
          {headline && (
            <DfbHeadline
              headline={headline}
              headline_level="h2"
              add_class="c-Headline m-PaginatedTable-headline dfb-Headline--h2 dfb-Headline"
            />
          )}
          {text && <DfbRte text={text} add_class="m-PaginatedTable-description" />}

          <div className="m-PaginatedTable-content">
            <div className="c-PaginatedTable">
              <table className="c-PaginatedTable-table">
                <thead className="c-PaginatedTable-table-head">
                  <tr>
                    <th className="c-PaginatedTable-table-head-column">Fanclub</th>
                    <th className="c-PaginatedTable-table-head-column">Stadt</th>
                  </tr>
                </thead>
                <tbody>
                  {fanclub_map_folder.map((fanclub) => (
                    <tr className="c-PaginatedTable-table-row">
                      <td className="c-PaginatedTable-table-row-column">{fanclub.name}</td>
                      <td className="c-PaginatedTable-table-row-column">{fanclub.city}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <div className="c-PaginatedTable-footer">
                <div className="c-PaginatedTable-pagination">
                  <button className="c-PaginatedTable-page-btn c-PaginatedTable-page-btn--first" disabled>
                    «
                  </button>
                  <button className="c-PaginatedTable-page-btn c-PaginatedTable-page-btn--prev" disabled>
                    ‹
                  </button>

                  <span className="c-PaginatedTable-current-page">1</span>

                  <button className="c-PaginatedTable-page-btn c-PaginatedTable-page-btn--next">›</button>
                  <button className="c-PaginatedTable-page-btn c-PaginatedTable-page-btn--last">»</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Section>
  )
}

export default MFanclubTable
